require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./community-partnerships-and-construction-sites.json") })
        }
      }, "path---community-partnerships-and-construction-sites");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---community-partnerships-and-construction-sites!./.cache/json/community-partnerships-and-construction-sites.json
// module id = 860
// module chunks = 231608221292675